"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LetterModalBody = LetterModalBody;
exports.ProjectSelectorModalBody = ProjectSelectorModalBody;
const react_1 = __importStar(require("react"));
const BussinesObjectSelectors_1 = require("../../../View/Modals/CommonFormComponents/BussinesObjectSelectors");
const react_bootstrap_1 = require("react-bootstrap");
const FormContext_1 = require("../../../View/Modals/FormContext");
const LettersController_1 = require("../LettersController");
const GenericComponents_1 = require("../../../View/Modals/CommonFormComponents/GenericComponents");
const InlineCreateDrawer_1 = require("../../../View/Modals/InlineCreateDrawer");
const CaseInlineCreateBody_1 = require("../../../TasksGlobal/Modals/Case/CaseInlineCreateBody");
const CaseModalBody_1 = require("../../../TasksGlobal/Modals/Case/CaseModalBody");
const CaseValidationSchema_1 = require("../../../TasksGlobal/Modals/Case/CaseValidationSchema");
const CaseModalButtons_1 = require("../../../TasksGlobal/Modals/Case/CaseModalButtons");
// Typ kamienia „projektowanie - nadzór” (MilestoneTypes.Id) — dla niego oferujemy
// opcję dodania pisma do „Dokumentacji zatwierdzonej”. Odpowiednik Setup.MilestoneTypes.DESIGN_SUPERVISION.
const DESIGN_SUPERVISION_MILESTONE_TYPE_ID = 6;
function LetterModalBody({ isEditing, initialData, getConfidenceClass = () => '', fileInputRef, }) {
    const { register, reset, setValue, watch, formState: { dirtyFields, errors, isValid }, trigger, } = (0, FormContext_1.useFormContext)();
    // fallback do initialData._project: przy odpowiedzi na pismo projekt jest znany z góry
    // (modal otwiera się bez ProjectSelectorModalBody, więc watch("_project") jest puste)
    const _project = isEditing
        ? undefined
        : watch("_project") ?? initialData?._project;
    // Panel inline-tworzenia Sprawy (Offcanvas) + token wymuszający odświeżenie opcji
    // selektora ze źródła prawdy (casesRepository.items) po utworzeniu/edycji sprawy.
    const [showCreateCase, setShowCreateCase] = (0, react_1.useState)(false);
    const [showEditCase, setShowEditCase] = (0, react_1.useState)(false);
    const [caseToEdit, setCaseToEdit] = (0, react_1.useState)(undefined);
    const [caseOptionsRefreshToken, setCaseOptionsRefreshToken] = (0, react_1.useState)(0);
    const _contract = watch("_contract");
    const _watchedCases = watch("_cases");
    // Opcja „Dokumentacja zatwierdzona” tylko gdy kontrakt ma włączoną flagę
    // i któraś wybrana sprawa należy do kamienia projektowanie - nadzór.
    const approvedDocsApplicable = _contract?.approvedDocumentation === true &&
        !!_watchedCases?.some((caseItem) => caseItem?._parent?._type?.id === DESIGN_SUPERVISION_MILESTONE_TYPE_ID);
    const creationDate = watch("creationDate");
    const registrationDate = watch("registrationDate");
    const responseDueDate = watch("responseDueDate");
    function getContractFromCases(_cases) {
        if (!_cases || _cases.length === 0)
            return undefined;
        return _cases[0]._parent?._contract;
    }
    // Po utworzeniu sprawy w panelu: addNewItem dopisał ją już do casesRepository.items
    // (źródło prawdy). Auto-zaznaczamy ją w `_cases` i podbijamy token, by selektor
    // przebudował opcje z repository.items. Nie mutujemy stanu poza setValue/setState.
    function handleCaseCreated(newCase) {
        const created = LettersController_1.casesRepository.items.find((item) => item.id === newCase.id) ?? newCase;
        const current = watch("_cases") ?? [];
        const alreadySelected = current.some((item) => item.id === created.id);
        const nextCases = alreadySelected ? current : [...current, created];
        setValue("_cases", nextCases, { shouldValidate: true });
        setCaseOptionsRefreshToken((token) => token + 1);
    }
    // Po edycji sprawy: editItem zaktualizował casesRepository.items (źródło prawdy).
    // Zastępujemy edytowaną sprawę w `_cases` i podbijamy token, by selektor odświeżył opcje.
    function handleCaseEdited(editedCase) {
        const updated = LettersController_1.casesRepository.items.find((item) => item.id === editedCase.id) ?? editedCase;
        const current = watch("_cases") ?? [];
        const nextCases = current.map((item) => (item.id === updated.id ? updated : item));
        setValue("_cases", nextCases, { shouldValidate: true });
        setCaseOptionsRefreshToken((token) => token + 1);
    }
    (0, react_1.useEffect)(() => {
        const nowUTC = new Date().toISOString().split("T")[0];
        const toDateInput = (value) => {
            if (!value)
                return "";
            const iso = value.match(/^(\d{4}-\d{2}-\d{2})/);
            return iso ? iso[1] : "";
        };
        const resetData = {
            id: initialData?.id,
            _contract: getContractFromCases(initialData?._cases),
            _cases: initialData?._cases || [],
            description: initialData?.description || "",
            creationDate: initialData?.creationDate || nowUTC,
            registrationDate: initialData?.registrationDate || nowUTC,
            _editor: initialData?._editor,
            relatedLetterNumber: initialData?.relatedLetterNumber || "",
            responseDueDate: toDateInput(initialData?.responseDueDate),
            addedToApprovedDocumentation: initialData?.addedToApprovedDocumentation ? 1 : 0,
        };
        if (!isEditing)
            resetData._project = _project;
        reset(resetData);
        trigger();
    }, [initialData, reset]);
    (0, react_1.useEffect)(() => {
        if (!dirtyFields._contract)
            return;
        setValue("_cases", undefined, { shouldValidate: true });
        // zmiana kontraktu unieważnia zaznaczenie „dokumentacji zatwierdzonej”
        setValue("addedToApprovedDocumentation", 0, { shouldValidate: true });
    }, [_contract, _contract?.id, setValue]);
    (0, react_1.useEffect)(() => {
        trigger(["creationDate", "registrationDate", "responseDueDate"]);
    }, [trigger, watch, creationDate, registrationDate, responseDueDate]);
    (0, react_1.useEffect)(() => {
        if (!isEditing)
            setValue("registrationDate", creationDate);
    }, [setValue, creationDate, isEditing]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "_contract" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Wybierz kontrakt"),
            react_1.default.createElement(BussinesObjectSelectors_1.ContractSelector, { name: "_contract", _project: _project, readOnly: !isEditing })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, null,
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Dotyczy spraw"),
            _contract ? (react_1.default.createElement(BussinesObjectSelectors_1.CaseSelectMenuElement, { name: "_cases", repository: LettersController_1.casesRepository, _project: _project, _contract: _contract, readonly: !_contract, onRequestCreate: () => setShowCreateCase(true), onRequestEdit: (caseItem) => {
                    setCaseToEdit(caseItem);
                    setShowEditCase(true);
                }, refreshToken: caseOptionsRefreshToken })) : (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning" }, "Wybierz kontrakt, by przypisa\u0107 do spraw"))),
        approvedDocsApplicable && (react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "addedToApprovedDocumentation", className: "mt-2" },
            react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "checkbox", label: "Dodaj to pismo do \"Dokumentacji zatwierdzonej\"", checked: !!watch("addedToApprovedDocumentation"), onChange: (e) => setValue("addedToApprovedDocumentation", e.target.checked ? 1 : 0, {
                    shouldValidate: true,
                }) }))),
        react_1.default.createElement(InlineCreateDrawer_1.InlineCreateDrawer, { show: showCreateCase, onHide: () => setShowCreateCase(false), title: "Nowa sprawa", headerBadge: (0, CaseModalButtons_1.buildContractHeaderBadge)(_contract), repository: LettersController_1.casesRepository, ModalBodyComponent: CaseInlineCreateBody_1.CaseInlineCreateBody, additionalModalBodyProps: { _contract }, makeValidationSchema: CaseInlineCreateBody_1.makeInlineCaseValidationSchema, onCreated: handleCaseCreated }),
        react_1.default.createElement(InlineCreateDrawer_1.InlineCreateDrawer, { show: showEditCase, onHide: () => setShowEditCase(false), title: "Edytuj spraw\u0119", headerBadge: (0, CaseModalButtons_1.buildCaseHeaderBadge)(caseToEdit?._parent, caseToEdit?.parentCaseId
                ? LettersController_1.casesRepository.items.find((c) => c.id === caseToEdit.parentCaseId)
                : undefined), repository: LettersController_1.casesRepository, ModalBodyComponent: CaseModalBody_1.CaseModalBody, makeValidationSchema: CaseValidationSchema_1.makeCaseValidationSchema, isEditing: true, initialData: caseToEdit, onEdited: handleCaseEdited }),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "description" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Opis"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 3, placeholder: "Podaj opis", isValid: !errors?.description, isInvalid: !!errors?.description, ...register("description") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "description", errors: errors })),
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, controlId: "creationDate" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Data utworzenia"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "date", isValid: !errors.creationDate, isInvalid: !!errors.creationDate, ...register("creationDate"), className: getConfidenceClass("creationDate") }),
                react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "creationDate", errors: errors })),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, controlId: "registrationDate" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Data Nadania"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "date", isValid: !errors.registrationDate, isInvalid: !!errors.registrationDate, ...register("registrationDate") }),
                react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "registrationDate", errors: errors }))),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "_editor" },
            react_1.default.createElement(BussinesObjectSelectors_1.RegisteringEditorSelector, { label: "Osoba rejestruj\u0105ca", name: "_editor" })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "file" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Plik"),
            react_1.default.createElement(GenericComponents_1.FileInput, { ...register("file"), inputRef: fileInputRef }),
            isEditing && (react_1.default.createElement(react_bootstrap_1.Form.Text, { className: "text-muted small" }, "Wcze\u015Bniej za\u0142\u0105czone pliki s\u0105 widoczne na dysku w folderze pisma. System nie zapami\u0119tuje tych plik\u00F3w jako warto\u015Bci pola wyboru pliku."))),
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, controlId: "relatedLetterNumber" }, _contract ? (react_1.default.createElement(BussinesObjectSelectors_1.LetterSelector, { name: "relatedLetterNumber", label: "Numer powi\u0105zanego pisma", _contract: _contract })) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Numer powi\u0105zanego pisma"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: "Najpierw wybierz kontrakt", disabled: true })))),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, controlId: "responseDueDate" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Odpowiedzie\u0107 do"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "date", isValid: !errors.responseDueDate, isInvalid: !!errors.responseDueDate, ...register("responseDueDate"), className: getConfidenceClass("responseDueDate") }),
                react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "responseDueDate", errors: errors })))));
}
/** przełęcza widok pomiędzy wyborem projektu a formularzem pisma
 * SpecificContractModalBody - komponent formularza kontraktu (OurContractModalBody lub OtherContractModalBody)
 * @param additionalProps - dodatkowe propsy przekazywane do SpecificContractModalBody - ustawiane w Otjer lub OurContractModalBody
 * w tym przypadku jest additionalProps zawiera tylko parametr SpecificContractModalBody - komponent formularza kontraktu (OurContractModalBody lub OtherContractModalBody)
 *
 */
function ProjectSelectorModalBody({ isEditing, additionalProps }) {
    const { register, setValue, watch, formState } = (0, FormContext_1.useFormContext)();
    const _project = watch("_project");
    //musi być zgodna z nazwą w Our... lub OtherContractModalBody
    const { SpecificLetterModalBody } = additionalProps;
    if (!SpecificLetterModalBody)
        throw new Error("SpecificContractModalBody is not defined");
    return (react_1.default.createElement(react_1.default.Fragment, null, _project ? (react_1.default.createElement(SpecificLetterModalBody, { isEditing: isEditing, additionalProps: additionalProps })) : (react_1.default.createElement(BussinesObjectSelectors_1.ProjectSelector, { name: "_project" }))));
}
